/**
 * Similar products matcher, used by the sold-out banner and the
 * "Not Quite What You're Looking For?" recommended products row.
 * Each [data-sos-scope] element carries matching criteria as data
 * attributes. The type collection's public products.json is fetched and
 * filtered to strict matches (in stock, same product type, same size tag,
 * price within band), ranked same brand + model family > same brand >
 * rest, closest price within each tier, and rendered as up to N cards.
 * Zero matches shows the scope's fallback element, or hides the scope
 * entirely if it has none.
 */
(function () {
  function formatPrice(pence) {
    var pounds = pence / 100;
    var hasPennies = pence % 100 !== 0;
    return '£' + pounds.toLocaleString('en-GB', {
      minimumFractionDigits: hasPennies ? 2 : 0,
      maximumFractionDigits: hasPennies ? 2 : 0
    });
  }

  function imageUrl(product) {
    var img = product.images && product.images[0] && product.images[0].src;
    if (!img) return '';
    return img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=480';
  }

  function sizeLabel(product) {
    var tags = product.tags || [];
    for (var i = 0; i < tags.length; i++) {
      if (/^(XXS|XS|S|M|L|XL|XXL) \(/.test(tags[i])) {
        return 'Size ' + tags[i].split(' ')[0];
      }
    }
    return '';
  }

  function availableVariant(product) {
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) return product.variants[i];
    }
    return null;
  }

  /**
   * Basic card built from products.json data. Only used when the
   * server-rendered card fetch fails for a product.
   */
  function buildBasicCard(product) {
    var card = document.createElement('a');
    card.className = 'sold-out-similar__card';
    card.href = '/products/' + product.handle;

    var imageWrap = document.createElement('div');
    imageWrap.className = 'sold-out-similar__card-image';
    var img = imageUrl(product);
    if (img) {
      var el = document.createElement('img');
      el.src = img;
      el.alt = product.title;
      el.loading = 'lazy';
      imageWrap.appendChild(el);
    }
    card.appendChild(imageWrap);

    var titlebox = document.createElement('div');
    titlebox.className = 'sold-out-similar__card-titlebox';
    var title = document.createElement('div');
    title.className = 'sold-out-similar__card-title';
    title.textContent = product.title;
    titlebox.appendChild(title);
    card.appendChild(titlebox);

    var meta = sizeLabel(product);
    if (meta) {
      var metaEl = document.createElement('div');
      metaEl.className = 'sold-out-similar__card-meta';
      metaEl.textContent = meta;
      card.appendChild(metaEl);
    }

    var pricing = document.createElement('div');
    pricing.className = 'sold-out-similar__card-pricing';
    var price = document.createElement('span');
    price.className = 'sold-out-similar__card-price';
    price.textContent = formatPrice(product._sosPrice);
    pricing.appendChild(price);
    card.appendChild(pricing);

    var btn = document.createElement('span');
    btn.className = 'sold-out-similar__card-btn';
    btn.textContent = 'View Bike';
    card.appendChild(btn);

    return card;
  }

  /**
   * Fetch each match's card server-rendered via the Section Rendering API
   * (sections/sold-out-similar-card.liquid), which has metafield access
   * for the Brand/Model/Year title and Size/Shifters pills.
   */
  function fetchCard(product) {
    return fetch('/products/' + product.handle + '?section_id=sold-out-similar-card')
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.querySelector('.sold-out-similar__card') || buildBasicCard(product);
      })
      .catch(function () {
        return buildBasicCard(product);
      });
  }

  function initScope(scope) {
    if (scope.dataset.sosInit) return;
    scope.dataset.sosInit = 'true';

    var sourceId = parseInt(scope.dataset.productId, 10);
    var sourceType = scope.dataset.type;
    var sourcePrice = parseInt(scope.dataset.price, 10); // pence
    var sizeTag = scope.dataset.sizeTag || '';
    var sourceVendor = (scope.dataset.vendor || '').toLowerCase();
    // First word of the model metafield, e.g. "Emonda SL 6" -> "emonda",
    // so other bikes in the same model family rank ahead of the rest
    var sourceModelFamily = (scope.dataset.model || '').trim().split(/\s+/)[0].toLowerCase();
    var collectionHandle = scope.dataset.collection;
    var band = (parseInt(scope.dataset.priceBand, 10) || 25) / 100;
    var maxProducts = parseInt(scope.dataset.maxProducts, 10) || 5;

    var row = scope.querySelector('[data-sos-row]');
    var fallback = scope.querySelector('[data-sos-fallback]');
    var subtext = scope.querySelector('[data-sos-subtext]');

    var minPrice = sourcePrice * (1 - band);
    var maxPrice = sourcePrice * (1 + band);

    function fetchPage(page) {
      return fetch('/collections/' + collectionHandle + '/products.json?limit=250&page=' + page)
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function (data) {
          return data.products || [];
        });
    }

    function matches(product) {
      if (product.id === sourceId) return false;
      if (product.product_type !== sourceType) return false;
      if (sizeTag && (product.tags || []).indexOf(sizeTag) === -1) return false;
      var variant = availableVariant(product);
      if (!variant) return false;
      var pricePence = Math.round(parseFloat(variant.price) * 100);
      if (isNaN(pricePence) || pricePence < minPrice || pricePence > maxPrice) return false;
      product._sosPrice = pricePence;
      return true;
    }

    function renderCards(products) {
      return Promise.all(products.map(fetchCard)).then(function (cards) {
        row.innerHTML = '';
        cards.forEach(function (card) {
          row.appendChild(card);
        });
      });
    }

    function showFallback() {
      if (fallback) {
        row.hidden = true;
        if (subtext) subtext.hidden = true;
        fallback.hidden = false;
        return;
      }
      scope.style.display = 'none';
      // Also collapse a wrapper that would otherwise leave an empty flex
      // item (and its gaps) behind
      if (scope.dataset.sosEmptyHide) {
        var hideEl = scope.closest(scope.dataset.sosEmptyHide);
        if (hideEl) hideEl.style.display = 'none';
      }
      // Optionally reshape the host block when empty, e.g. the internal
      // links section swaps from split layout back to its stacked layout
      if (scope.dataset.sosEmptyTarget && scope.dataset.sosEmptyClass) {
        var target = scope.closest(scope.dataset.sosEmptyTarget);
        if (target) {
          target.classList.add(scope.dataset.sosEmptyClass);
          if (scope.dataset.sosEmptyRemove) {
            target.classList.remove(scope.dataset.sosEmptyRemove);
          }
        }
      }
    }

    if (!collectionHandle || !row) {
      showFallback();
      return;
    }

    fetchPage(1)
      .then(function (products) {
        if (products.length === 250) {
          return fetchPage(2).then(function (more) {
            return products.concat(more);
          }).catch(function () {
            return products;
          });
        }
        return products;
      })
      .then(function (products) {
        var matched = products.filter(matches);
        // Rank tiers: same brand + model family, then same brand, then the
        // rest; closest price breaks ties within each tier
        function tier(product) {
          var brandMatch = sourceVendor && (product.vendor || '').toLowerCase() === sourceVendor;
          if (!brandMatch) return 2;
          if (sourceModelFamily && product.title.toLowerCase().indexOf(sourceModelFamily) !== -1) return 0;
          return 1;
        }
        matched.sort(function (a, b) {
          return tier(a) - tier(b) ||
            Math.abs(a._sosPrice - sourcePrice) - Math.abs(b._sosPrice - sourcePrice);
        });
        matched = matched.slice(0, maxProducts);
        if (matched.length) {
          renderCards(matched);
        } else {
          showFallback();
        }
      })
      .catch(function () {
        showFallback();
      });
  }

  document.querySelectorAll('[data-sos-scope]').forEach(initScope);
})();
